export default __webpack_public_path__ + "static/media/05.4581f091.jpg";